var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8815 0H5.1185C2.29163 0 0 2.29163 0 5.1185V18.8815C0 21.7084 2.29163 24 5.1185 24H18.8815C21.7084 24 24 21.7084 24 18.8815V5.1185C24 2.29163 21.7084 0 18.8815 0Z",
    fill: "#007471"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2998 8.35977C18.7736 8.59272 18.2155 8.74558 17.6441 8.81326C18.2417 8.45469 18.6987 7.8887 18.9096 7.21725C18.3443 7.55231 17.7262 7.78887 17.0816 7.91682C16.6866 7.49282 16.173 7.1977 15.6078 7.06995C15.0426 6.9422 14.4521 6.98776 13.9131 7.20067C13.3742 7.41358 12.9119 7.78398 12.5867 8.26353C12.2614 8.74308 12.0882 9.30953 12.0897 9.88899C12.089 10.1102 12.1137 10.3308 12.1635 10.5464C11.0168 10.4889 9.89502 10.191 8.87091 9.67193C7.8468 9.15291 6.94324 8.42439 6.21885 7.53364C5.84829 8.16862 5.73435 8.92118 5.90034 9.63739C6.06632 10.3536 6.49968 10.9793 7.11177 11.3866C6.65317 11.3722 6.20471 11.248 5.80403 11.0245V11.0596C5.80403 12.4588 6.7989 13.6259 8.11719 13.8896C7.6931 14.0053 7.2481 14.0221 6.81648 13.9388C7.00083 14.5116 7.35939 15.0125 7.84213 15.3718C8.32487 15.731 8.90771 15.9305 9.50931 15.9426C8.91095 16.4129 8.22568 16.7606 7.49274 16.9657C6.75981 17.1708 5.99361 17.2293 5.23804 17.1379C6.51415 17.957 8.02931 18.4315 9.66048 18.4315C14.9688 18.4315 17.8691 14.0372 17.8691 10.223C17.8691 10.0999 17.8691 9.97688 17.862 9.85032C18.4245 9.44604 18.9167 8.9363 19.3034 8.35977H19.2998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.ae1eea2845a7e25ac107830bb1097e0d.svg";
export { ForwardRef as ReactComponent };